export const normalizeBetData = (data = []) => {
  //   let newData = { ...data };
  //   newData.forEach((item, index) => {
  //     const itemFound = newData.find(({ value }) => value === item.value);
  //     if (itemFound) {
  //       itemFound.amount = data[index].amount + itemFound.amount;
  //       newData = newData.splice(index, 1);
  //     }
  //   });
  //   return newData;
};

export const isOddExists = (odd, data = [], currentPrice) => {
  console.log({ data });
  return data.find(({ value }) => parseInt(value) == parseInt(odd));
};
export const getNewOddVaue = (odd, data = [], currentPric) => {
  const item = data.find(({ value }) => value == odd);
  if (item) return parseInt(item.amount) + parseInt(currentPric);
  return currentPric;
};



// WEBPACK FOOTER //
// ./src/utils/index.js